module.exports = __webpack_public_path__ + "static/media/pickup.7061a3c7.svg";